var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgF1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 49,
    viewBox: "0 0 47 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.5335 32.4437C15.5448 38.4099 7.58984 38.4099 7.58984 38.4099C7.58984 38.4099 7.58984 30.455 13.5561 28.4662",
    stroke: "white",
    strokeWidth: 1.46739,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.4323 18.5224L23.4999 30.4548L15.5449 22.4998L27.4773 10.5674C31.9957 6.04909 36.514 6.09317 38.4409 6.38067C38.7376 6.42489 39.0122 6.56326 39.2243 6.77537C39.4364 6.98748 39.5748 7.26211 39.619 7.5588C39.9065 9.48574 39.9506 14.004 35.4323 18.5224Z",
    stroke: "white",
    strokeWidth: 1.46739,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.4417 20.5111V31.861C33.4417 32.0457 33.4054 32.2286 33.3347 32.3992C33.264 32.5698 33.1604 32.7248 33.0299 32.8554L27.3448 38.5405C27.1648 38.7205 26.9393 38.8482 26.6925 38.9101C26.4456 38.9721 26.1865 38.9658 25.9429 38.892C25.6993 38.8183 25.4803 38.6798 25.3092 38.4913C25.1381 38.3029 25.0214 38.0715 24.9715 37.8219L23.498 30.4548",
    stroke: "white",
    strokeWidth: 1.46739,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4901 12.5563H14.1402C13.9555 12.5563 13.7726 12.5926 13.602 12.6633C13.4314 12.734 13.2764 12.8376 13.1458 12.9682L7.46071 18.6532C7.28073 18.8332 7.15297 19.0587 7.09106 19.3056C7.02915 19.5524 7.03541 19.8115 7.10917 20.0551C7.18293 20.2987 7.32142 20.5177 7.50988 20.6888C7.69834 20.8599 7.9297 20.9766 8.17929 21.0265L15.5464 22.5",
    stroke: "white",
    strokeWidth: 1.46739,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: -4.625,
    y: -2.34375,
    width: 56.25,
    height: 56.25,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.28125
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.8125
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgF1);
export default __webpack_public_path__ + "static/media/f1.2e75f54a773ade52ea4d44dd75b1cffc.svg";
export { ForwardRef as ReactComponent };